import React from "react";
import Parser from 'html-react-parser';

class ResultsPricing extends React.Component {
  render() {
    return (
      !this.props.newPriceLayout ? (
        <>
          <div className={`product__info--options ${this.props.addingToCart ? 'disabled' : ''}`}>
            <label htmlFor="Monthly" className="plan-select subscription">
              <input id="Monthly" type="radio" name="planType" value="Monthly" checked="checked" onChange={this.props.changeSelectedProduct} />
              <div className="option active">
                <div>Subscribe &amp; Save</div>
              </div>
            </label>
            <label htmlFor="OneOff" className="plan-select oneOff">
              <input id="OneOff" type="radio" name="planType" value="OneOff" onChange={this.props.changeSelectedProduct} />
              <div className="option">
                <div>One Time</div>
              </div>
            </label>

            <div className="product__info--options-content">
              <div className="option-info styled">
                <div className="product__info--display Monthly active">
                  <label htmlFor="purchase-type" className="select-label">How often would you like your delivery?</label>
                  <div className="orderFrequency">
                    <div className="select-container">
                      <select name="purchase-type" id="purchaseType" defaultValue={4} onChange={this.props.changeSelectedProduct}>
                        <option value="4">Every 4 weeks - Most Popular</option>
                        <option value="12">Every 12 weeks - 3 boxes at a time</option>
                        <option value="52">Pay Annually - Delivered every 4 weeks</option>
                      </select>
                    </div>
                  </div>
                  <p>Cancel anytime | Fully edit your subscription</p>
                </div>
                <div className="product__info--display OneOff">
                  <p><strong>You could save up to 30% with a subscription</strong> You've selected a one-time purchase. Why not switch to our fully flexible subscription and save up to 30% on each box of Nourished?</p>
                </div>
                <div className="pricing">
                  <div className="pricing-left">
                    <span className="subscription-priceOld" id="subPriceOld">{this.props.subPriceOld}</span>
                    <span className="subscription-price" id="subPrice">{this.props.subPrice}</span>
                    <span className="subscription-savings" id="subSavings">{this.props.subSavings}</span>
                    <span className="deliveryText">{this.props.deliveryText}</span>
                  </div>
                  <div className="pricing-right">
                    <span className="small">{this.props.numberOfBoxes} | {this.props.numberOfStacks} gummies</span>
                    <span className="pricePerBar subscriptionPerBar"><span id="pricePerDay">{this.props.pricePerStack}</span> per day</span>
                  </div>
                </div>
                {this.props.discountText ?
                  <>
                    <div className="results-subscription-option__discount active">
                      {Parser(this.props.discountText)}
                    </div>
                  </> : ''
                }
              </div>
            </div>
          </div>
          <button
            type="button"
            id="purchaseAddToCart"
            disabled={this.props.addingToCart}
            data-productid={this.props.purchaseID}
            className={`btn btn-primary ${this.props.addingToCart ? 'loading' : ''}`}
            onClick={this.props.addToCart}>{this.props.purchaseText}</button>

          <div class="order-arrival">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.4043 1.65442L14.7499 8.00007L8.4043 14.3457" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M14.7499 8L1.25 8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <p>Orders are made fresh—please allow up to 10 working days for delivery. Note: Due to high order volumes, there may be slight shipping delays</p>
          </div>
        </>
      ) : (
        <>
          <span className="pricing-header">Free Delivery • Cancel Anytime • Save when you subscribe</span>
          <div className="pricing-box">
            <div className={`pricing-item ${this.props.planType === 'monthly' ? 'active' : ''}`} onClick={() => this.props.subPlan('monthly', this.props.monthlySubId, 'Subscribe')}>
              <div className="pricing-item__title">
                <span className="pricing-item__title__radio"></span>
                <div>
                  <span>Every 28 days</span>
                  Subscribe
                </div>
              </div>
              <div className="pricing-item__cost">
                <span className="pricing-item__offer">{this.props.nplDiscountText}</span>
                <div className="pricing-item__price">
                  <span className="pricing-item__ppd">{this.props.offerPricePerStack} PER DAY</span>
                  {this.props.offerPrice}
                </div>
                <span className="pricing-item__regular">{this.props.monthlyPrice} /month after 1st box</span>
              </div>
            </div>

            <div className={`pricing-item ${this.props.planType === 'one-off' ? 'active' : ''}`} onClick={() => this.props.subPlan('one-off', this.props.oneOffSubId, 'Add To Cart')}>
              <div className="pricing-item__title">
                <span className="pricing-item__title__radio"></span>
                One Time Purchase
              </div>
              <div className="pricing-item__cost">
                <div className="pricing-item__price">
                  <span className="pricing-item__ppd">{this.props.oneOffPricePerStack} PER DAY</span>
                  {this.props.oneOffPrice}
                </div>
              </div>
            </div>
          </div>
          <div className="pricing-more">
            <div id="badge-ribbon" className="scale-review"></div>
            {!this.props.showBundle && (
              <div className="pricing-more__title" onClick={this.props.toggleBundle}>
                Want to save more?
                <svg enableBackground="new 0 0 29 14" viewBox="0 0 29 14" width="9px"><polygon fill="#231F20" points="0.15,0 14.5,14.35 28.85,0 " /></svg>
              </div>
            )}
            {this.props.showBundle && (
              <div className="pricing-more__title" onClick={this.props.toggleBundle}>
                Hide options
                <svg style={{ transform: "rotate(180deg)" }} enableBackground="new 0 0 29 14" viewBox="0 0 29 14" width="9px"><polygon fill="#231F20" points="0.15,0 14.5,14.35 28.85,0 " /></svg>
              </div>
            )}
          </div>

          {this.props.showBundle && (
            <div className="pricing-box pricing-box--bulk">
              <div className={`pricing-item ${this.props.planType === 'threeBoxBundle' ? 'active' : ''}`} onClick={() => this.props.subPlan('threeBoxBundle', this.props.threeBoxBundleSubId, 'Subscribe')}>
                <div className="pricing-item__title">
                  <span className="pricing-item__title__radio"></span>
                  <div>
                    <span>3 Month Subscription</span>
                    Pay every 12 weeks
                  </div>
                </div>
                <div className="pricing-item__cost">
                  <span className="pricing-item__offer">£119.97</span>
                  <div className="pricing-item__price">
                    <span className="pricing-item__ppd">SAVE 25%</span>
                    £90
                  </div>
                  <span className="pricing-item__regular">3 boxes delivered every 12 weeks</span>
                </div>
              </div>

              <div className={`pricing-item ${this.props.planType === 'annual' ? 'active' : ''}`} onClick={() => this.props.subPlan('annual', this.props.annualSubId, 'Subscribe')}>
                <div className="pricing-item__title">
                  <span className="pricing-item__title__radio"></span>
                  <div>
                    <span>1 Year Subscription</span>
                    Pay annually
                  </div>
                </div>
                <div className="pricing-item__cost">
                  <span className="pricing-item__offer">£519.87</span>
                  <div className="pricing-item__price">
                    <span className="pricing-item__ppd">SAVE 30%</span>
                    £360
                  </div>
                  <span className="pricing-item__regular">1 box delivered every 4 weeks</span>
                </div>
              </div>
            </div>
          )}

          <button
            type="button"
            id="purchaseAddToCart"
            disabled={this.props.addingToCart}
            data-productid={this.props.purchaseID}
            className={`btn btn-primary pricing-layout ${this.props.planType} ${this.props.addingToCart ? 'loading' : ''}`}
            onClick={this.props.addToCart}>{this.props.purchaseText}</button>
        </>
      )
    );
  }
}

export default ResultsPricing;